export const GAUGE_SPECS = {
  degree: Math.PI / 180,
  lineCount: 5,
  smallLineCount: 10,
  lineColor: '#545667',
  labelColor: '#8E91A1',
  labelFontSize: 13,
  lineStrokeSmall: 1,
  lineStrokeLarge: 3,
  tickSizeSmall: 9,
  tickSizeLarge: 18,
  minFontSize: 22,
  minLineWidth: 24,
  valueColor: '#ffffff',
  needleColor0: '#434453',
  needleColor1: '#ffffff',
}
